<div (click)="toggle()" [ngClass]="{'checked': ngModel}"></div>
<label *ngIf="isString(label)" (click)="toggle()" [ngClass]="{'checked': ngModel}">{{label}}</label>
<app-info *ngIf="info" [content]="info"></app-info>
<label *ngIf="isArray(label)" (click)="toggle()" [ngClass]="{'checked': ngModel}"><span *ngFor="let part of label" [ngClass]="part.className">{{part.text}}</span></label>